import { StyleSheet, type ViewProps } from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import { defaultShadow } from '@themes/Shadows'
import type currency from 'currency.js'

/**
 * Internal Views
 * - Do not maintain state
 */

export interface NeedCardViewPropsBase {
  id: number
  organizationName: string
  title: string
  shortDescription: string
  priceIncludingTip: currency.Any
  city?: string
  state?: string
  containerProps?: ViewProps
}

//#region Styles
export const styles = StyleSheet.create({
  containerBase: {
    flexGrow: 0,
    flexShrink: 0,
    // flexBasis: '100%',

    userSelect: 'none',

    position: 'relative',
  },

  containerLive: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    ...defaultShadow,
  },
  containerMet: {
    borderRadius: 12,
  },
  containerMetInternal: {
    backgroundColor: Colors.white,
    // flex: 1,
    // justifyContent: 'center',
  },
  containerMetInternal_normal: {
    borderRadius: 11,
    margin: 1,
  },
  containerMetInternal_withThankYou: {
    borderRadius: 10,
    margin: 2,
  },
})

export const cardStyles = StyleSheet.create({
  header: {
    paddingHorizontal: 12,
    paddingTop: 12,
    paddingBottom: 8,
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
  },
  body: {
    paddingHorizontal: 12,
  },
  footer: {
    // flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
  },
})

export const itemStyles = StyleSheet.create({
  orgImageWrapper: {
    width: 24,
    height: 24,
    position: 'relative',
    borderWidth: 1,
    borderColor: '#e9eaee',
    borderRadius: 24 / 2,
    borderStyle: 'solid',
    // @ts-ignore
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  orgName: {
    fontFamily: Fonts.type.alternateBold,
    fontWeight: 'bold',
    fontSize: Fonts.size.medium,
    color: Colors.primary,
    textTransform: 'uppercase',
  },
  needTitle: {
    fontSize: 20,
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    color: Colors.black,
  },
  needDescription: {
    fontFamily: Fonts.type.regular,
    fontSize: 15,
    lineHeight: 15 * 1.3,
    color: Colors.descriptionGray,
  },
  badgesContainer: {
    paddingHorizontal: 6,
    position: 'absolute',
    width: '100%',
    top: -12,
    // right: 0,
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-end',

    zIndex: 50,
  },
})
